import request, { METHOD, requestSet, requestExportPost } from '@/utils/request'
import { API_PROXY_PREFIX } from '@/services/api'

// 查询列表-工单信息
export function apiMesDiscreteJobsDispatchList (query) {
  return request({
    url: '/mes/mesDiscreteJobs/dispatch/list',
    method: 'post',
    data: query
  })
}

// 修改-工单信息
export function apiMesDiscreteJobsUpdate (data) {
  return request({
    url: '/mes/mesDiscreteJobs',
    method: 'put',
    data: data
  })
}

// 发放
export function apiMesDiscreteJobsGrant (data) {
  return request({
    url: '/mes/mesDiscreteJobs/grant',
    method: 'put',
    data: data
  })
}

// 发放&派工撤回
export function apiMesDispatchReleaseDispatchRecall (id) {
  return request({
    url: `/mes/mesDispatch/releaseDispatchRecall/${id}`,
    method: 'put'
  })
}

// 工单暂停
export function apiMesDispatchWorkOrderSuspension (id) {
  return request({
    url: `/mes/mesDispatch/workOrderSuspension/${id}`,
    method: 'put'
  })
}

// 提交
export function apiMesDiscreteJobsSubmitTo (data) {
  return request({
    url: `/mes/mesDiscreteJobs/submitTo`,
    method: 'put',
    data: data
  })
}

// 查询列表-工单用料表
export function apiMesRequirementOperationsDispatchList (query) {
  return request({
    url: '/mes/mesRequirementOperations/dispatch/list',
    method: 'get',
    params: query
  })
}

// 查询列表-工单工序
export function apiMesOperationsDispatchList (query) {
  return request({
    url: '/mes/mesOperations/dispatch/list',
    method: 'get',
    params: query
  })
}

// 查询列表-关联工单
export function apiMesDiscreteJobsDispatchAssociatedWorkOrderList (query) {
  return request({
    url: '/mes/mesDiscreteJobs/dispatch/associatedWorkOrderList',
    method: 'get',
    params: query
  })
}

// 新增-工单派工
export function apiMesDispatchAdd (data) {
  return request({
    url: '/mes/mesDispatch',
    method: 'post',
    data: data
  })
}

// 下拉框-加工组织
export function apiUserInventOrg (query) {
  return request({
    url: `/system/user/inventOrg`,
    method: 'get',
    params: query
  })
}

// 下拉框-车间
export function apiMesDiscreteJobsWorkCodeBox (query) {
  return request({
    url: '/mes/mesDiscreteJobs/workCodeBox',
    method: 'get',
    params: query
  })
}

// 下拉框-产线
export function apiMesDiscreteJobsLineCodeBox (query) {
  return request({
    url: '/mes/mesDiscreteJobs/lineCodeBox',
    method: 'get',
    params: query
  })
}

// 下拉框-工单分类
export function apiMesDiscreteJobsClassCodeBox (query) {
  return request({
    url: '/mes/mesDiscreteJobs/classCodeBox',
    method: 'get',
    params: query
  })
}

// 开工
export function apiMesDispatchStartWork (wipEntityId) {
  return request({
    url: `/mes/mesDispatch/startWork/${wipEntityId}`,
    method: 'post'
  })
}

// 报工-零部件页
export function apiMesDispatchWorkReportingPartsPage (wipEntityId) {
  return request({
    url: `/mes/mesDispatch/workReportingPartsPage/${wipEntityId}`,
    method: 'post'
  })
}

// 报工-零部件
export function apiMesDispatchWorkReportingParts (data) {
  return request({
    url: `/mes/mesDispatch/workReportingParts`,
    method: 'post',
    data: data
  })
}

// 完工-零部件页
export function apiMesDispatchWipCompletionPage (wipEntityId) {
  return request({
    url: `/mes/mesDispatch/wipCompletionPage/${wipEntityId}`,
    method: 'post'
  })
}

// 工单导出
export function apiDiscreteJobsExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/dispatch/v2/export',
    method: 'post',
    data: data
  })
}

// 关联工单导出
export function apiAssociatedWorkOrderExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/dispatch/associatedWorkOrder/v2/export',
    method: 'post',
    data: data
  })
}

// 工单用料
export function apiRequirementOperationsExport (data) {
  return request({
    url: '/mes/mesRequirementOperations/dispatch/v2/export',
    method: 'post',
    data: data
  })
}

// 工单工序
export function apiMesOperationsExport (data) {
  return request({
    url: '/mes/mesOperations/dispatch/v2/export',
    method: 'post',
    data: data
  })
}

// 完工-零部件
export function apiMesDispatchWipCompletion (data) {
  return request({
    url: `/mes/mesDispatch/wipCompletion`,
    method: 'post',
    data: data
  })
}

// 成品质检
export function apiMesDispatchInspectionAssemblyCenter (wipEntityId, query) {
  return request({
    url: `/mes/mesDispatch/inspectionAssemblyCenter/${wipEntityId}`,
    method: 'get',
    params: query
  })
}

// 成品质检-检验方式确认
export function apiMesDispatchInspectMode (data) {
  return request({
    url: `/mes/mesDispatch/inspectMode`,
    method: 'post',
    data: data
  })
}

// 成品质检-保存
export function apiMesDispatchInspectionQuality (data) {
  return request({
    url: `/mes/mesDispatch/inspectionQuality`,
    method: 'post',
    data: data
  })
}

// 完工-组装中心 下拉框数据
export function apiMesDispatchCompletionAssemblyCenterPageBox (wipEntityId) {
  return request({
    url: `/mes/mesDispatch/completionAssemblyCenterPage/box/${wipEntityId}`,
    method: 'get'
  })
}

// 完工-组装中心-保存
export function apiMesDispatchCompletionAssemblyCenter (data) {
  return request({
    url: `/mes/mesDispatch/completionAssemblyCenter`,
    method: 'post',
    data: data
  })
}

// 打印派工资料
export function apiMesDispatchPrintDispatchInformation (id) {
  return request({
    url: `/mes/mesDispatch/printDispatchInformation/${id}`,
    method: 'get'
  })
}

// 打印合格证/标签-列表
export function apiMesDiscreteJobsPrintCertificateConformityPage (wipEntityId) {
  return request({
    url: `/mes/mesDiscreteJobs/printCertificateConformityPage/${wipEntityId}`,
    method: 'get'
  })
}

// 打印合格证/标签-标签码列表
export function apiMesDiscreteJobsSerialNumberPopup (wipEntityId) {
  return request({
    url: `/mes/mesDiscreteJobs/serialNumberPopup/${wipEntityId}`,
    method: 'get'
  })
}

// 打印合格证-数据
export function apiMesDiscreteJobsPrintCertificateConformity (query) {
  return requestSet(`/mes/mesDiscreteJobs/printCertificateConformity`, METHOD.POST, query)
}

// 工单派工-打印领料单获取打印列表
export function apiMesDispatchGetMaterialPrintList (data) {
  return request({
    url: `/mes/mesDispatch/getMaterialPrintList`,
    method: 'post',
    data: data
  })
}

// 工单工作台-打印领料单获取打印列表
export function apiMesDiscreteJobsGetMaterialPrintList (data) {
  return request({
    url: `/mes/mesDiscreteJobs/getMaterialPrintList`,
    method: 'post',
    data: data
  })
}

// 更新打印领料单次数
export function apiMesUpdateMaterialRequisitionPrintTimes (data) {
  return request({
    url: `/mes/mesDispatch/updateMaterialRequisitionPrintTimes`,
    method: 'post',
    data: data
  })
}

// 检查派工是否超出计划
export function apiMesCheckDispatchQuantity (data) {
  return request({
    url: `/mes/mesDispatch/checkDispatchQuantity`,
    method: 'post',
    data: data
  })
}

// 更新派工数量
export function apiMesUpdateMesRequirementDispatchQuantity (data) {
  return request({
    url: `/mes/mesDispatch/updateMesRequirementDispatchQuantity`,
    method: 'post',
    data: data
  })
}

// 生成领料单号
export function apiMesGenerateDispatchNumber (data) {
  return request({
    url: `/mes/mesDispatch/generateDispatchNumber?number=${data.number}`,
    method: 'post',
    data: data
  })
}

// 打印标签-数据
export function apiMesDiscreteJobsPrintLabel (query) {
  // return request({
  //   url: '/mes/mesDiscreteJobs/printLabel',
  //   method: 'post',
  //   params: query
  // })
  return requestSet(`/mes/mesDiscreteJobs/printLabel`, METHOD.POST, query)
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 工单批量关闭
export function apiMesDiscreateBatchClose (data) {
  return request({
    url: `/mes/mesDiscreteJobs/batchClose`,
    method: 'post',
    data: data
  })
}

// 工单派工-下载安装图纸
export function apiMesDispatchDownloadDrawing (wipEntityIds, fileName) {
  return requestExportPost(
    `${API_PROXY_PREFIX}/mes/mesDispatch/downloadDrawing`,
    wipEntityIds,
    fileName
  )
}
